import { rest_api_url } from "../../constants/urls";
import ApiService from "../../utils/apiServices";

// Add vendors
export const handleSaveVendors = ({
  newVendor,
  vendorsData,
  setVendorsData,
  setNewVendors,
  setShowAddVendorModal,
  setLoadingStatus,
  alert_notify,
}) => {
  try {
    if (!newVendor) {
      alert_notify("error", "Please write client name");
      return false;
    }
    let data = {
      name: newVendor,
    };
    setLoadingStatus(true);
    new Promise((resolve, reject) => {
      ApiService.post(rest_api_url.create_client, resolve, reject, data, true);
    })
      .then((response) => {
        alert_notify("success", "Client has been added successfully");
        setLoadingStatus(false);
        var data = response;
        setVendorsData([
          ...vendorsData,
          {
            partner_name: newVendor,
            id: data.partner_id,
            account_id: data.account_id,
            active: 1,
          },
        ]);
        setShowAddVendorModal(false);
        setNewVendors("");
      })
      .catch((err) => {
        alert_notify("error", err.response.data.error.message);
        setLoadingStatus(false);
      });
  } catch (e) {
    alert_notify("error", e?.message);
  }
};

export const storeSelectedClient = ({ id }) => {
  localStorage.setItem("selectedClients", JSON.stringify([id]));
  localStorage.setItem("client-id", id);
};

export const reconcileActiveClient = (partnerId) => {
  const storedClientId = localStorage.getItem("client-id");
  if (partnerId && storedClientId && String(storedClientId) !== String(partnerId)) {
    storeSelectedClient({ id: partnerId });
    return true;
  }
  localStorage.setItem("client-id", partnerId);
  return false;
};

let clientSwitchInFlight = false;

export const setUserPartnerId = ({
  id,
  account_id,
  history,
  setClientLoading,
  setLoadingStatus,
  alert_notify,
}) => {
  if (clientSwitchInFlight) return;
  clientSwitchInFlight = true;
  try {
    let data = {
      partner_id: id,
    };
    let pathName = history?.location?.pathname || "";
    setClientLoading(true);
    new Promise((resolve, reject) => {
      ApiService.put(rest_api_url.user_change_partner, resolve, reject, data, true);
    })
      .then(() => {
        storeSelectedClient({ id });
        if (pathName === "/clients" || pathName.indexOf("/clients/profile/") > -1) {
          window.location.href = `/clients/profile/${account_id}`;
        } else {
          window.location.reload();
        }
      })
      .catch((err) => {
        clientSwitchInFlight = false;
        setLoadingStatus(false);
        setClientLoading(false);
        if (!err?.message) alert_notify("error", "Could not change client");
      });
  } catch (e) {
    clientSwitchInFlight = false;
    setLoadingStatus(false);
    setClientLoading(false);
    alert_notify("error", e?.message);
  }
};

export const handleProductionEnv = async ({ status, setProductionEnv, alert_notify }) => {
  try {
    let data = {
      enabled_prod: status,
    };
    new Promise((resolve, reject) => {
      ApiService.put(rest_api_url.user_edit, resolve, reject, data, true);
    })
      .then((response) => {
        setProductionEnv(status);
        alert_notify("success", "Production status has been changed");
        window.location.reload(false);
      })
      .catch((err) => {
        alert_notify("error", err.message);
      });
  } catch (e) {
    alert_notify("error", e?.message);
  }
};
